export default __webpack_public_path__ + "static/media/no.87c3a905.svg";